import { render, staticRenderFns } from "./ItemConfig.vue?vue&type=template&id=19e4ddb9&scoped=true"
import script from "./ItemConfig.vue?vue&type=script&lang=js"
export * from "./ItemConfig.vue?vue&type=script&lang=js"
import style0 from "./ItemConfig.vue?vue&type=style&index=0&id=19e4ddb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e4ddb9",
  null
  
)

export default component.exports